module.exports = __webpack_public_path__ + "static/media/logo-commityourpeople.bf42482e.png";